import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  registrationForm: FormGroup;

  constructor(
    private readonly http: HttpClient,
    private readonly fb: FormBuilder,
    public readonly modalRef: BsModalRef,
    private readonly toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.registrationForm = this.fb.group({
      username: new FormControl('', {
        validators: [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(30),
        ],
      }),
      email: new FormControl('', {
        validators: [Validators.required, Validators.email],
      }),
      password: new FormControl('', {
        validators: [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(30),
        ],
      }),
      passwordAgain: new FormControl('', {
        validators: [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(30),
        ],
      }),
    });
  }

  register() {
    if (this.registrationForm.invalid) {
      return;
    }
    this.http
      .post('/api/register', this.registrationForm.getRawValue())
      .subscribe(
        (resp) => {
          this.modalRef.hide();
          this.toastr.success(
            'User created, an email will be sent to your email address, click on the link to complete your registration!',
          );
        },
        (error) => {
          console.log(error);
          this.toastr.error(error.error);
        },
      );
  }
}
